<template>
  <a-select
    :getPopupContainer="(target) => target.parentNode"
    :placeholder="'请选择'"
    :disabled="disabled"
    :value="getValueSting"
    @change="handleInput"
    :size="size"
    :show-arrow="true"
    :multiple="multiple"
  >
    <a-select-option
      v-for="(item, key) in dictOptions"
      :key="key"
      :value="item.value"
    >
      <span
        style="display: inline-block; width: 100%"
        :title="item.text || item.label"
      >
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
/**
 * author 周娇
 * desc 下拉选择框-查询字典接口
 * params:
 *  dictCode : 字典值
 *  disabled : 是否禁用
 *  value : 初始化的值-默认选中
 *  size : 尺寸
 *  multiple 是否支持多选
 *
 */
import { ajaxGetDictItems } from '@/api/api';

export default {
  name: 'SelectDict',
  props: {
    dictCode: String,
    disabled: Boolean,
    value: [String, Number],
    size: {
      type: String,
      default: 'default',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dictOptions: [],
    };
  },
  created() {
    this.initDictData();
  },
  computed: {
    getValueSting() {
      return this.value != null ? this.value.toString() : undefined;
    },
  },
  methods: {
    initDictData() {
      //根据字典Code, 初始化字典数组
      ajaxGetDictItems(this.dictCode, null).then((res) => {
        if (res.success) {
          this.dictOptions = res.result;
        }
      });
    },
    handleInput(e) {
      this.$emit('change', e);
    },
  },
};
</script>
